// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_PERMISSIONS_REQUEST_SUCCESS,
  GET_PERMISSIONS_REQUEST_ERROR,
  GET_PERMISSIONS_REQUEST,
} from "../constants";
import axios from "../../../services/api";

function* getPermissionsRequest(data) {
  try {
    const response = yield call(axios.get, `/permissions`);
    if (response.data.error) {
      yield put({
        type: GET_PERMISSIONS_REQUEST_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_PERMISSIONS_REQUEST_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: GET_PERMISSIONS_REQUEST_ERROR,
      data: error,
    });
  }
}

export default function* getPermissionsRequestSaga() {
  yield takeLatest(GET_PERMISSIONS_REQUEST, getPermissionsRequest);
}
